import axios from "@/plugins/axios.js";
const API_URL = "/api/common";

export default {
  ApiTest() {
    return axios.get("/api-test");
  },
  async GetCompetitions() {
    return axios.get(`${API_URL}/competitions`);
  },
};
